import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";

export default function SlowChart({ filters, searchKey }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        if (!filters.day) return;
        const { day, startTime, endTime, clientMsgId } = filters;
        const start = new Date(`${day}T${startTime}:00`);
        const end = new Date(`${day}T${endTime}:00`);
        axios
            .post("/logs/slow/statistics", {
                day: day.replaceAll("-", ""),
                start_time: start.toISOString(),
                end_time: end.toISOString(),
            })
            .then((res) => setData(res.data || []))
            .catch(() => setData([]));
    }, [searchKey]);

    return (
        <div className="bg-white rounded-2xl border p-4 mb-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">
                Thống kê Slow Push theo thời gian
            </h3>

            <ResponsiveContainer width="100%" height={260}>
                <LineChart data={data}>
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="count_5s"
                        stroke="#f59e0b"
                        name="> 5s"
                    />
                    <Line
                        type="monotone"
                        dataKey="count_10s"
                        stroke="#dc2626"
                        name="> 10s"
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
